export default {
    en: {
        id: 'exercise1',
        title: 'To get early warning of market shifts, we need to',
        titles: ['Define the market segments', ' Assess competitive position in each segment', 'Track changes in position over time'],
        answers: [
            {
                title: 'Have a problem'
            },
            {
                title: 'Know the solution'
            },
            {
                title: 'How implement?'
            }
        ],
        boxes: [
            {
                name: 'box1',
                title: 'Time',
            },
            {
                name: 'box2',
                title: 'Structure',
            },
            {
                name: 'box3',
                title: 'Degree',
            }
        ],
        correctAnswers: {
            box1: true,
            box2: false,
            box3: false
        },
        userAnswers: {
            box1: false,
            box2: false,
            box3: false
        },
        text: 'The reasoning here is cause-and-effect. If I define the segments, assess competitive position in each segment, and track changes in position over time, I will get early warning of market shifts. The summary of a set of actions is always the direct effect of carrying out the actions.'
    }
}


// WEBPACK FOOTER //
// ./client/app/modules/courses/6/identifyingLogicaOrder/i18n/exercise1.js